import { render, staticRenderFns } from "./OrderCardPayment.vue?vue&type=template&id=1e9725a6&scoped=true"
import script from "./OrderCardPayment.vue?vue&type=script&lang=ts"
export * from "./OrderCardPayment.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e9725a6",
  null
  
)

export default component.exports